import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import PortalAxios, { baseURL } from '../../services/PortalAxios';

export const getCart = createAsyncThunk('portalCart/getCart', async (_, { rejectWithValue }) => {
    try {
        const res = await PortalAxios.PortalRequest({ method: 'get', url: `${baseURL}/portal/cart` });
        return res.data.data;
    } catch (err) { return rejectWithValue(err.response?.data?.message || 'Failed to load cart'); }
});

export const addToCart = createAsyncThunk('portalCart/addToCart', async ({ productId, quantity }, { rejectWithValue }) => {
    try {
        const res = await PortalAxios.PortalRequest({ method: 'post', url: `${baseURL}/portal/cart/add`, data: { productId, quantity } });
        return res.data.data;
    } catch (err) { return rejectWithValue(err.response?.data?.message || 'Failed to add item'); }
});

export const updateCartItem = createAsyncThunk('portalCart/updateItem', async ({ productId, quantity }, { rejectWithValue }) => {
    try {
        const res = await PortalAxios.PortalRequest({ method: 'patch', url: `${baseURL}/portal/cart/update`, data: { productId, quantity } });
        return res.data.data;
    } catch (err) { return rejectWithValue(err.response?.data?.message || 'Failed to update item'); }
});

export const removeCartItem = createAsyncThunk('portalCart/removeItem', async (productId, { rejectWithValue }) => {
    try {
        const res = await PortalAxios.PortalRequest({ method: 'delete', url: `${baseURL}/portal/cart/item/${productId}` });
        return res.data.data;
    } catch (err) { return rejectWithValue(err.response?.data?.message || 'Failed to remove item'); }
});

export const clearCart = createAsyncThunk('portalCart/clearCart', async (_, { rejectWithValue }) => {
    try {
        const res = await PortalAxios.PortalRequest({ method: 'delete', url: `${baseURL}/portal/cart/clear` });
        return res.data.data;
    } catch (err) { return rejectWithValue(err.response?.data?.message || 'Failed to clear cart'); }
});

const emptyCart = { items: [], totals: { subtotal: 0, itemCount: 0 } };

const portalCartSlice = createSlice({
    name: 'portalCart',
    initialState: { cart: emptyCart, loading: false, error: null },
    reducers: {},
    extraReducers: (builder) => {
        const setCart = (state, action) => { state.loading = false; state.cart = action.payload || emptyCart; };
        builder
            .addCase(getCart.fulfilled, setCart)
            .addCase(addToCart.fulfilled, setCart)
            .addCase(updateCartItem.fulfilled, setCart)
            .addCase(removeCartItem.fulfilled, setCart)
            .addCase(clearCart.fulfilled, setCart)
            .addMatcher(
                (action) => action.type.startsWith('portalCart/') && action.type.endsWith('/pending'),
                (state) => { state.loading = true; state.error = null; }
            )
            .addMatcher(
                (action) => action.type.startsWith('portalCart/') && action.type.endsWith('/rejected'),
                (state, action) => { state.loading = false; state.error = action.payload; }
            );
    }
});

export default portalCartSlice.reducer;
